"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.containerWidth = exports.SingleChoiceAppDataField = exports.labelHelper = exports.helpContainer = exports.AppDataFieldFactory = undefined;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _DataField = require("../../../cms/reducers/designer/CMSReport/DataField");

var _HeaderAppDataField = require("./fields/HeaderAppDataField");

var _HeaderAppDataField2 = _interopRequireDefault(_HeaderAppDataField);

var _ChoiceAppDataField2 = require("./fields/ChoiceAppDataField");

var _ChoiceAppDataField3 = _interopRequireDefault(_ChoiceAppDataField2);

var _DateAppDataField = require("./fields/DateAppDataField");

var _DateAppDataField2 = _interopRequireDefault(_DateAppDataField);

var _DrawAppDataField = require("./fields/DrawAppDataField");

var _DrawAppDataField2 = _interopRequireDefault(_DrawAppDataField);

var _ImageAppDataField = require("./fields/ImageAppDataField");

var _ImageAppDataField2 = _interopRequireDefault(_ImageAppDataField);

var _NumAppDataField = require("./fields/NumAppDataField");

var _NumAppDataField2 = _interopRequireDefault(_NumAppDataField);

var _TextAppDataField = require("./fields/TextAppDataField");

var _TextAppDataField2 = _interopRequireDefault(_TextAppDataField);

var _SelectTypeAppDataField = require("./fields/SelectTypeAppDataField");

var _SelectTypeAppDataField2 = _interopRequireDefault(_SelectTypeAppDataField);

var _TableAppDataField = require("./fields/TableAppDataField");

var _TableAppDataField2 = _interopRequireDefault(_TableAppDataField);

var _TableNoColumnsAppDataField = require("./fields/TableNoColumnsAppDataField");

var _TableNoColumnsAppDataField2 = _interopRequireDefault(_TableNoColumnsAppDataField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppDataFieldFactory = exports.AppDataFieldFactory = function AppDataFieldFactory() {
    _classCallCheck(this, AppDataFieldFactory);
};

AppDataFieldFactory.appDataFieldForDataField = function (dataField, contentDataField, reportData) {
    var isWithinTable = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

    if (dataField instanceof _DataField.HeaderDataField) {
        return new _HeaderAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.DateDataField) {
        return new _DateAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.TextDataField) {
        return new _TextAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.NumDataField) {
        return new _NumAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.TextDataField) {
        return new _TextAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.DrawDataField) {
        return new _DrawAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.ImageDataField) {
        return new _ImageAppDataField2.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.ChoiceDataField && dataField.isSingleChoice === false) {
        return new _ChoiceAppDataField3.default(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.ChoiceDataField && dataField.isSingleChoice === true) {
        return new SingleChoiceAppDataField(dataField, contentDataField, isWithinTable);
    }
    if (dataField instanceof _DataField.TableDataField) {
        if (dataField.props && dataField.props.fields && dataField.props.fields.length === 0) {
            return new _TableNoColumnsAppDataField2.default(dataField, contentDataField, reportData, isWithinTable);
        }
        return new _TableAppDataField2.default(dataField, contentDataField, reportData, isWithinTable);
    }
    if (dataField instanceof _DataField.SelectTypeDataField) {
        return new _SelectTypeAppDataField2.default(dataField, contentDataField, reportData, isWithinTable);
    }
    console.error("AppDataFieldFactory.constructor: unsupported Datafield", dataField, contentDataField, reportData, isWithinTable);
    return null;
};
var helpContainer = exports.helpContainer = function helpContainer(valid, firstLine, secondLine) {
    var dangerClass = valid ? "help-primary" : "help-danger";
    return React.createElement("div", { className: dangerClass }, React.createElement("span", { style: { display: "block" } }, firstLine), function () {
        if (secondLine) {
            return React.createElement("span", { style: { display: "block" } }, secondLine);
        }
    }());
};
var labelHelper = exports.labelHelper = function labelHelper(title, isMandatory, isWithinTable, formattedMessage) {
    if (isWithinTable) {
        return null;
    }
    if (isMandatory) {
        return title;
    }
    if (formattedMessage) {
        return title + " " + formattedMessage({ id: "appDataField.title.optional" });
    } else {
        return title;
    }
};
// This field is still defined here, as then are issues with TypeScript circular references
// TypeError: Super expression must either be null or a function
// Should be moved to fields/SingleChoiceAppDataField.tsx after import tree has been flattened

var SingleChoiceAppDataField = exports.SingleChoiceAppDataField = function (_ChoiceAppDataField) {
    _inherits(SingleChoiceAppDataField, _ChoiceAppDataField);

    function SingleChoiceAppDataField(dataField, contentDataField) {
        var isWithinTable = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

        _classCallCheck(this, SingleChoiceAppDataField);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SingleChoiceAppDataField).call(this, dataField, contentDataField, isWithinTable));

        _this.setValue = function (value) {
            value = value || null;
            if (_.isArray(value)) {
                _.set(_this, "contentDataField.data.choices", _.head(value));
            } else {
                _.set(_this, "contentDataField.data.choices", value);
            }
        };
        _this.currentFormValue = function () {
            var value = (0, _selectn2.default)("data.choices", _this.contentDataField);
            return value;
        };
        _this.appSchemaObject = function () {
            var options = {};
            _.set(options, _this.key(), _this.dataField.isMandatory ? t.String : t.maybe(t.String));
            return options;
        };
        _this.appSchemaStruct = function () {
            return t.struct(_this.appSchemaObject(), _this.dataField.uid);
        };
        _this.addItem = function (dispatch, text) {
            _.set(_this.contentDataField, "data.freeTextValues", [text]);
            _this.setValue(text);
            // saves report when adding new option
            _this.dispatchUpdate(dispatch);
        };
        _this.copy = function () {
            return new SingleChoiceAppDataField(_this.dataField, _this.contentDataField, _this.isWithinTable);
        };
        _this.contentDataField = contentDataField;
        _this.dataField = dataField;
        _this.isWithinTable = isWithinTable;
        _this.contentDataField = Object.assign({}, contentDataField, {
            type: "choice",
            uid: dataField.uid
        });
        _this.setValue(_this.currentFormValue());
        return _this;
    }

    return SingleChoiceAppDataField;
}(_ChoiceAppDataField3.default);

var containerWidth = exports.containerWidth = "500px";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/AppDataField.tsx
 ** module id = 58
 ** module chunks = 0
 **/